import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { ShareLinkIcon, Tooltip } from "@flat-ui";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
import { SnapshotOptionsMenu } from "@pages/project-details/project-snapshots/snapshot-options-menu";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { IconButton } from "@flat-ui";
import { SnapshotShareDialog } from "@pages/project-details/project-snapshots/snapshot-share-dialog";
import { useState } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { SnapshotEvents } from "@utils/track-event/track-event-list";

/** Renders the options for a snapshot, including sharing and 3-dot menu */
export function SnapshotOptions(t0) {
  const $ = _c(19);
  const {
    snapshot
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      justifyContent: "right",
      visibility: "hidden"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDialogOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== snapshot.accessLevel || $[3] !== snapshot.id || $[4] !== trackEvent) {
    t3 = e => {
      e.stopPropagation();
      e.preventDefault();
      trackEvent({
        name: SnapshotEvents.openShareSnapshot,
        props: {
          snapshotId: snapshot.id,
          accessLevel: snapshot.accessLevel,
          location: "snapshot-table-row"
        }
      });
      setIsDialogOpen(true);
    };
    $[2] = snapshot.accessLevel;
    $[3] = snapshot.id;
    $[4] = trackEvent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ShareLinkIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <Tooltip component="div" title="Share snapshot"><IconButton onClick={t3} size="s">{t4}</IconButton></Tooltip>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isDialogOpen || $[10] !== snapshot || $[11] !== t5) {
    t6 = <SnapshotShareDialog snapshot={snapshot} isOpen={isDialogOpen} onClose={t2} location="snapshot-action">{t5}</SnapshotShareDialog>;
    $[9] = isDialogOpen;
    $[10] = snapshot;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SphereActionDivider />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== snapshot) {
    t8 = <SnapshotOptionsMenu snapshot={snapshot} />;
    $[14] = snapshot;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <Stack direction="row" sx={t1} className={SHOW_ON_HOVER_CLASS}>{t6}{t7}{t8}</Stack>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}